import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';

@Pipe({
  name: 'enumDescription',
  standalone: true,
})
export class EnumDescriptionPipe implements PipeTransform {
  private readonly enumDescriptionMap: { [key: string]: string } = {

    // AccountStatusEnum
    USER_ACTIVE: 'Cadastro Regular',
    USER_CADASTER_PROCESS: 'Em Processo de Cadastro',
    PROVIDER_PF_ACTIVE: 'Cadastro PF Regular',
    PROVIDER_PF_EXPIRED_PLAN: 'Plano PF Expirado',
    PROVIDER_PF_CADASTER_PROCESS: 'Em Processo de Cadastro PF',
    PROVIDER_PJ_ACTIVE: 'Cadastro PJ regular ',
    PROVIDER_PJ_EXPIRED_PLAN: 'Plano PJ Expirado',
    PROVIDER_PJ_CADASTER_PROCESS: 'Em Processo de Cadastro PJ',
    CUSTOMERSERVICE_OPENED: 'Registro Aberto',
    CUSTOMERSERVICE_INCHAT: 'Em Andamento',
    CUSTOMERSERVICE_CLOSED: 'Atendimento Concluido',

    // BillingUnitEnum 
    HOUR: 'Hora',
    SERVICE: 'Atendimento',
    SHIFT: 'Turno',

    // BusinessTypeEnum
    HOSPITAL: 'Hospital',
    CLINICA: 'Clínica',
    HOMECARE: 'Home Care',
    DIAGNOSTICO: 'Centro de Diagnóstico',
    HOSPITALDIA: 'Hospital Dia',
    LABORATORIO: 'Laboratório',
    PRONTOATENDIMENTO: 'Pronto Atendimento',
    OPERADORA: 'Operadora de Saúde',
    ADMINISTRADORHOSPITALAR: 'Administrador Hospitalar',

    // CouncilGroupEnum
    CRF: 'Conselho Regional De Farmácia',
    CRM: 'Conselho Regional De Medicina',
    COREN: 'Conselho Regional De Enfermagem',
    CRP: 'Conselho Regional De Psicologia',
    CRN: 'Conselho Regional De Nutrição',
    CREFONO: 'Conselho Regional De Fonoaudiologia',
    CREFITO: 'Conselho Regional De Fisioterapia',
    CRESS: 'Conselho Regional De Serviço Social',
    CRBM: 'Conselho Regional De Biomedicina ',

    // CustomerServiceRequestTypeEnum
    SUBJECT: 'Assunto',
    DESCRIPTION: 'Descrição',

    // DistrictEnum 
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',

    // NegotiationReferenceTypeEnum
    SERVICE_OFFERING: 'Oferta de Consultas',
    SERVICE_DEMAND: 'Demanda de Consultas',
    RESOURCE_OFFERING: 'Oferta de Exames',
    RESOURCE_DEMAND: 'Demanda de Exames',

    // NegotiationStatusEnum
    PENDING: 'Pendente aceite do convite',
    ACCEPTED: 'Convite aceito',
    REJECTED: 'Negociação rejeitada',
    CANCELLED: 'Negociação cancelada',
    IN_PROGRESS: 'Negociação em andamento',
    COMPLETED: 'Negociação concluída',

    // PackageTypeEnum
    SUBSCRIPTION_PROVIDER_PF_FREE : "Pacote basico para profissionais pessoa física",
    SUBSCRIPTION_PROVIDER_PF_BASIC : "Pacote completo para profissionais pessoa física - Starter",
  
    SUBSCRIPTION_LAB_FREE : "Pacote básico para laboratórios",
    SUBSCRIPTION_LAB_BASIC : "Pacote completo para laboratórios - Basic",
    SUBSCRIPTION_LAB_PERSONAL : "Pacote personalizado para laboratórios",
  
    SUBSCRIPTION_PROVIDER_PJ_FREE : "Pacote básico para empresas prestadoras",
    SUBSCRIPTION_PROVIDER_PJ_2 : "Pacote para empresas prestadoras com até 2 Profissionais",
    SUBSCRIPTION_PROVIDER_PJ_6 : "Pacote para empresas prestadoras com até 6 Profissionais",
    SUBSCRIPTION_PROVIDER_PJ_10 : "Pacote para empresas prestadoras com até 10 Profissionais",
    SUBSCRIPTION_PROVIDER_PJ_PERSONAL : "Pacote para empresas prestadoras com mais de 10 Profissionais",
  
    SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE : "Pacote híbrido básico para empresas",
    SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100 : "Pacote híbrido para empresas com até 100 conexoes",
    SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL : "Pacote híbrido personalizado para empresas",
  
    SUBSCRIPTION_CONTRACTOR_PJ_120 : "Pacote para empresas contratantes com até 120 conexoes",
    SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL : "Pacote personalizado para empresas contratantes ",
  
    SUBSCRIPTION_ADMINISTRATOR : "Pacote para administradores e mantenedotas  da rede",
  

    // PlanStatusEnum
    NO_PLAN: 'Sem plano',// 'Nenhum plano encontrado para este usuário',
    ACTIVE: 'Ativo', //'Plano ativo e em dia',
    INACTIVE: 'Inativo',// 'Plano inativo',

    /**
     * Plano próximo ao vencimento (dentro de 7 dias)
     */
    EXPIRING_SOON: 'Expirando em breve',// 'Plano próximo ao vencimento, renove para continuar com acesso',
    EXPIRED: 'Expirado', // 'Plano expirado renove para reativar o acesso',
    PAYMENT_OVERDUE: 'Pagamento atrasado',// 'Há pagamentos pendentes, regularize para manter o acesso',
    SUSPENDED: 'Suspenso',// 'Plano suspenso por falta de pagamento',
    TRIAL: 'Período de teste',// 'Plano em período de teste',
    PENDING_PAYMENT: 'Aguardando pagamento',// 'Plano criado, aguardando geração do primeiro pagamento',

    // ResourceEnum
    EXAME_LABORATORIAL: 'Exame Laboratorial',
    ECOGRAFIA: 'Ecografia',
    TOMOGRAFIA: 'Tomografia',
    RESSONANCIA_MAGNETICA: 'Ressonância Magnética',
    RAIO_X: 'Raio-X',
    MAMOGRAFIA: 'Mamografia',
    ELETROCARDIOGRAMA_REPOUSO: 'Eletrocardiograma em Repouso',
    ELETROENCEFALOGRAMA: 'Eletroencefalograma',
    ESPIROMETRIA: 'Espirometria',
    VIDEO_NASOFIBROSCOPIA: 'Vídeo Nasofibroscopia',
    VIDEO_ENDOSCOPIA_NASOSSINUSAL: 'Vídeo Endoscopia Nasossinusal',
    MAPA: 'MAPA',
    TESTE_ERGOMETRICO: 'Teste Ergométrico',
    ENDOSCOPIA_COLONOSCOPIA: 'Endoscopia/Colonoscopia',
    POLISSONOGRAFIA: 'Polissonografia',
    AUDIOMETRIAS: 'Audiometrias',
    CINTILOGRAFIA: 'Cintilografia',
    GENETICA: 'Genética',
    ANATOMOPATOLOGICO: 'Anatomopatológico',
    PET_SCAN: 'PET Scan',
    HEMODIALISE: 'Hemodiálise',
    QUIMIOTERAPIA: 'Quimioterapia',
    RADIOTERAPIA: 'Radioterapia',

    // ServiceFormatEnum
    PRESENTIAL: 'Presencial',
    TELECONSULTA: 'Teleconsulta',

    // StatusOpenServiceEnum
    DRAFT: 'Rascunho',
    OPEN: 'Aberto',
    CLOSE: 'Fechado',


    // UserPreferenceTypeEnum
    AUTO_SHARE_DOCUMENTS: 'Compartilhamento automático de documentos', // 
    //  'Permite que documentos sejam automaticamente compartilhados com quem solicitar'
    EMAIL_NOTIFICATIONS: 'Notificações por email',
    // 'Receber notificações por email sobre atividades da conta'
    SMS_NOTIFICATIONS: 'Notificações por SMS',
    //  'Receber notificações por SMS sobre atividades importantes'
    AUTO_ACCEPT_NEGOTIATIONS: 'Aceitar negociações automaticamente',
    // 'Aceitar automaticamente negociações que atendam aos critérios definidos'
    PROFILE_VISIBILITY: 'Visibilidade do perfil',
    // 'Controlar a visibilidade do perfil para outros usuários'
    DATA_SHARING_CONSENT: 'Consentimento para compartilhamento de dados',
    // 'Permitir o compartilhamento de dados para melhorar os serviços'
    MARKETING_COMMUNICATIONS: 'Comunicações de marketing',
    //  'Receber comunicações promocionais e de marketing'

    // UserRoleEnum
    OWNER: 'Proprietário',
    LEADER: 'Líder',
    MEMBER: 'Membro',

    //PaymentMethodEnum
    CREDIT_CARD: 'Cartão de Crédito',
    PIX: 'Pix',
    BOLETO: 'Boleto Bancário',
    BANK_TRANSFER: 'Transferência Bancária',

    // PaymentStatusEnum && // InstallmentStatusEnum
    // PENDING_PAYMENT: 'Aguardando pagamento',
    PARTIALLY_PAID: 'Parcialmente pago',
    PAID: 'Pago',
    FAILED: 'Falha no pagamento',
    LATE: 'Atrasado',
    CANCELLED_PAID: 'Pagamento cancelado',

    // SOMENTE NO ANGULAR
    // GroupFaq 
    PLATAFORMA: 'Sobre a Plataforma',
    USUARIO: 'Perfis de Usuário',
    SEGURANCA: 'Documentação e Segurança',
    FUNCIONALIDADES: 'Funcionalidades',
    PAGAMENTOS: 'Planos e Pagamentos',
    TECNICO: 'Aspectos Técnicos',
  }

  transform(value: string | undefined | null): string {
    if (!value) return '—';
    return this.enumDescriptionMap[value] || value;
  }
}
